module.exports = __webpack_public_path__ + "img/new-consult2.ae47aa24.png";